import { LIQWID_POOLS_CONFIG } from '@/src/utils/tokens';
import { LiqwidPool } from './types';

export const LIQWID_POOLS: LiqwidPool[] = LIQWID_POOLS_CONFIG;
